export function isKatakanaChar(ch: string) {
  return (ch >= "\u30a0" && ch <= "\u30ff") || ch === "　";
}

export function isValid2ByteCharacters(str: string) {
  for (let i = 0; i < str?.length; i++) {
    const isKatakana = isKatakanaChar(str[i]);
    if (!isKatakana) {
      return false;
    }
  }
  return true;
}

export function isOnlySpaces(str: string) {
  const result = str.replace(/ /g, "");
  return !result.length;
}
